










import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class OrderItemsSummary extends Vue {
  // Props
  @Prop({ required: false, default: () => [] })
  public items!: [];

  @Prop({ default: "span" })
  public readonly tag!: string;

  // Methods

  public fieldFunc(item: any) {
    return this.$_.compact([
      this.$_.get(item, "product_name"),
      this.$_.get(item, "service_identifier")
        ? `(${this.$_.get(item, "service_identifier")})`
        : null
    ]).join(" ");
  }
}
